export function toRegExp(pattern: string): RegExp {
  const match = pattern.match(/^\/.*\/([a-z]*)$/)
  return match ? new RegExp(pattern, match[1]) : new RegExp(pattern)
}
